"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleContext = void 0;
const react_1 = require("react");
exports.LocaleContext = (0, react_1.createContext)(undefined);
